import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpHeaders } from '@angular/common/http';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { CompanyMasterProperties } from '../Models/CompanyMasterProperties';
import { error } from 'console';

@Injectable({
  providedIn: 'root'
})

export class companyMasterService {
  baseUrl = environment.baseUrl;
  // backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) {

  }



  AddCompanyMaster(companyMaster): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CompanyMaster/AddCompanyMaster', companyMaster).pipe(map((data: boolean) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  UpdateCompanyMaster(companyMaster): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/CompanyMaster/UpdateCompanyMaster', companyMaster).pipe(map((data: boolean) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  GetCompanyMaster(): Observable<CompanyMasterProperties[]> {
    return this.http.get<CompanyMasterProperties[]>(this.baseUrl + '/CompanyMaster/GetCompanyMasterAll').pipe(map((data: CompanyMasterProperties[]) => {
      return data;
    }), catchError(error => { return throwError(error) }))
  }
  GetCompanyMasterById(companyId):Observable<CompanyMasterProperties>{
    return this.http.get<CompanyMasterProperties>(this.baseUrl+'/CompanyMaster/GetCompanyMasterById?companyId='+companyId).pipe(map((data:CompanyMasterProperties)=>{
      return data;
    }),catchError(error=>{ return throwError(error)}))
  }




}
